import { injectable } from "inversify";
import * as Axios from "axios";
import autobind from "autobind-decorator";

@injectable()
export class ConfigurationService {
	public configuration: AppConfiguration

	@autobind
	public current(): Promise<AppConfiguration> {
		if (this.configuration) {
			return Promise.resolve(this.configuration);
		}
		return new Promise((resolve, reject) => {
			var http = Axios.default.create({
				timeout: 30000,
			});
			http.get("/api/v1/config")
				.then(result => {
					let flag: number = result.data.productCodeRequired;
					this.configuration = <AppConfiguration>{
						serviceUrl: result.data.serviceUrl,
						reportUrl: result.data.reportUrl,
						defaultLanguage: result.data.defaultLanguage,
						productCodeRequired: (flag > 0),
						version: result.data.version,
						versionDate: result.data.versionDate,
					};
					resolve(this.configuration);
				})
				.catch(reject);
		});
	}
}



// WEBPACK FOOTER //
// ./src/core/services/configuration.service.ts